import React from 'react';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { useCollectionStateContext } from 'Context/CollectionStateContext';
import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';
import { Layout } from './Layout';

const metaOverrideSet = buildFacetDesignOverride();

export const TaxDiagnosticNoteContent = () => {
  const {
    collection,
    setCollection,
  } = useCollectionStateContext();
  const resource = collection?.resources().head();

  if (!resource) {
    return null;
  }

  return (
    <MetaResourceRenderer
      layout={Layout}
      resource={resource}
      metaOverrideSet={metaOverrideSet}
      onSubmit={(resp) => setCollection(resp)}
    />
  );
};

TaxDiagnosticNoteContent.propTypes = {
};
